import { FC } from 'react'
import { useRouter } from 'next/router'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import useTranslation from 'next-translate/useTranslation'
import { FlexboxGrid } from 'rsuite'

import { deliveryHelper } from '../../../utils/util'
import { getCountryAndLocaleStrings } from '../../../utils/locales'
import CountryFlag from '../../Icons/CountryFlag'

interface DeliveryInfoWithFlagProps {
  deliveryTime: number
  freeShipping: boolean
  isRFQProduct: boolean
  className?: string
}

const DeliveryInfoWithFlag: FC<DeliveryInfoWithFlagProps> = ({
  deliveryTime,
  freeShipping,
  isRFQProduct,
  className,
}) => {
  const { locale: countryAndLocaleString } = useRouter()
  const { country } = getCountryAndLocaleStrings(countryAndLocaleString)
  const { t } = useTranslation('products')
  const isDeliveryFlagFeatureEnabled = useFeatureIsOn('delivery-info-with-country-flags')

  if (isRFQProduct) {
    return (
      <span className={className}>
        {t('Quote only')}
      </span>
    )
  }

  const deliveryText = deliveryHelper(deliveryTime, t, freeShipping)
  const freeText = freeShipping ? t('Free') : ''

  if (isDeliveryFlagFeatureEnabled && country) {
    return (
      <FlexboxGrid
        className={`flex-flow-row ${className}`}
        align="middle"
      >
        <CountryFlag countryId={country} />
        <span className="margin-left-spacer-half ellipsis">
          {freeText && (
            <>
              {freeText}
              &nbsp;
            </>
          )}
          {deliveryText}
        </span>
      </FlexboxGrid>
    )
  }

  // Fallback to original format without flag
  return (
    <span className={className}>
      {freeText && (
        <>
          {freeText}
          &nbsp;
        </>
      )}
      {deliveryText}
    </span>
  )
}

export default DeliveryInfoWithFlag
